import React from 'react';
import { Table } from 'antd';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';

const columns = [
  { title: 'Component', dataIndex: 'component', key: 'component', width: 200 },
  { title: 'Component Type', dataIndex: 'componentType', key: 'componentType', width: 130 },
];

export default function EarningDeductionTable({ data }) {
  const [notify, setNotify] = React.useState({ isOpen: false, message: '', type: '' });
  const [confirmDialog, setConfirmDialog] = React.useState({ isOpen: false, title: '', subTitle: '' });

  return (
    <div style={{ width: 400 }}>
      <Table
        columns={columns}
        dataSource={data}
        size="small"
        bordered
        pagination={{
          pageSize: 5,
          pageSizeOptions: ['5', '10', '20'],
          showSizeChanger: true,
        }}
      />
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </div>
  );
}
